import React from 'react';
import { View, TouchableOpacity, Text } from 'react-native';
import { ReportType } from '../types';
import { ScaledSheet } from '@utils/scale';

interface TabSelectorProps {
  selectedType: ReportType;
  onTypeChange: (type: ReportType) => void;
}

/**
 * TabSelector Component
 * Allows switching between Daily and Weekly reports
 */
const TabSelector: React.FC<TabSelectorProps> = ({
  selectedType,
  onTypeChange,
}) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={[
          styles.tab,
          styles.leftTab,
          selectedType === 'DAILY' && styles.activeTab,
        ]}
        onPress={() => onTypeChange('DAILY')}
        activeOpacity={0.8}
      >
        <Text
          style={[
            styles.tabText,
            selectedType === 'DAILY' && styles.activeTabText,
          ]}
        >
          Daily Report
        </Text>
      </TouchableOpacity>

      <TouchableOpacity
        style={[
          styles.tab,
          styles.rightTab,
          selectedType === 'WEEKLY' && styles.activeTab,
        ]}
        onPress={() => onTypeChange('WEEKLY')}
        activeOpacity={0.8}
      >
        <Text
          style={[
            styles.tabText,
            selectedType === 'WEEKLY' && styles.activeTabText,
          ]}
        >
          Weekly Report
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = ScaledSheet.create({
  container: {
    flexDirection: 'row',
    marginHorizontal: 16,
    marginTop: 16,
    gap: 12,
  },
  tab: {
    flex: 1,
    paddingVertical: 14,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: '#E0E0E0',
    backgroundColor: '#FFFFFF',
  },
  leftTab: {},
  rightTab: {},
  activeTab: {
    backgroundColor: '#2C2C2C',
    borderColor: '#2C2C2C',
  },
  tabText: {
    fontSize: 15,
    fontWeight: '600',
    color: '#666666',
  },
  activeTabText: {
    color: '#FFFFFF',
  },
});

export default TabSelector;


